// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_80-4";
export var collapsed = "_80-1";
export var headerBar = "_80-0";
export var leftHeaderContent = "_80-3";
export var subjectContainer = "_80-2";